import { useState } from 'react';
import { soloChallenge } from '../services/api';
import { useMetadata } from '../context/MetadataContext';
import { useGlobalError } from '../context/GlobalErrorContext';

/**
 * Creates a duel challenge from a finished solo puzzle, for SoloResults.
 * Failures are reported through triggerError.
 */
export const useSoloChallenge = () => {
  const { getText } = useMetadata();
  const { triggerError } = useGlobalError();
  const [isLoading, setIsLoading] = useState(false);

  /** @returns {Promise<string|null>} the challenge code, null on failure */
  const createChallenge = async () => {
    try {
      setIsLoading(true);
      const challengeData = await soloChallenge();
      
      if (challengeData && challengeData.challenge_code) {
        return challengeData.challenge_code;
      }
      triggerError({ 
        type: 'non-critical', 
        message: getText('solo_play.challenge_error', 'Failed to create challenge. Please try again.') 
      });
      return null;
    } catch (error) {
      console.error('Error creating challenge:', error);
      triggerError({ 
        type: 'non-critical', 
        message: getText('solo_play.challenge_error', 'Failed to create challenge. Please try again.'),
        error
      });
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, createChallenge };
};

export default useSoloChallenge;
